import React from "react";
import { motion } from "framer-motion";
import {
  Sun,
  Moon,
  Menu,
  X,
  User,
  Briefcase,
  Lightbulb,
  Images,
  Mail,
} from "lucide-react";
import "./Header.css";

const Header = ({ darkMode, toggleDarkMode, isMenuOpen, toggleMenu }) => {
  const navItems = [
    { title: "About", icon: <User size={20} /> },
    { title: "Experience", icon: <Briefcase size={20} /> },
    { title: "Projects", icon: <Lightbulb size={20} /> },
    { title: "Gallery", icon: <Images size={20} /> },
    { title: "Contact", icon: <Mail size={20} /> },
  ];

  return (
    <motion.header
      className="header"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="header-container">
        <nav className={`nav ${isMenuOpen ? "nav-open" : ""}`}>
          {navItems.map((item, index) => (
            <motion.a
              key={item.title}
              href={`#${item.title.toLowerCase()}`}
              className="nav-link"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              onClick={() => toggleMenu(false)}
              title={item.title}
            >
              {item.icon}
            </motion.a>
          ))}
        </nav>

        <div className="header-actions">
          <motion.button
            className="theme-toggle"
            onClick={(e) => { toggleDarkMode(); e.currentTarget.blur(); }}
            whileTap={{ scale: 0.9 }}
          >
            {darkMode ? <Sun size={20} /> : <Moon size={20} />}
          </motion.button>

          <motion.button
            className="menu-toggle"
            onClick={() => toggleMenu(!isMenuOpen)}
            whileTap={{ scale: 0.9 }}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </motion.button>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
